/* M21 — add to cart opens the cart drawer instead of jumping to /cart.
 *
 * WHY: the M21 Luxe product page renders its own form (#M21ProductForm) rather than
 * Shopify's <product-form> component, so nothing intercepted the submit. The browser
 * did a native POST and Shopify redirected to /cart. Two costs: the shopper was thrown
 * off the product page, and the 'product_added_to_cart' analytics event was destroyed
 * by the navigation before it could be sent (which is why the House Meta pixel recorded
 * zero add-to-carts while the Toronto one, which also reports server-side, recorded 20).
 *
 * FAIL-SAFE: if a usable <cart-drawer> is not on the page, we do NOT preventDefault and
 * the original behaviour is left completely untouched. Any error also falls back to /cart.
 */
(function () {
  function drawerEl() {
    var d = document.querySelector('cart-drawer');
    if (!d) return null;
    if (typeof d.getSectionsToRender !== 'function') return null;
    if (typeof d.renderContents !== 'function') return null;
    return d;
  }

  function bind() {
    var form = document.getElementById('M21ProductForm');
    if (!form || form.dataset.m21DrawerBound === '1') return;
    form.dataset.m21DrawerBound = '1';

    form.addEventListener('submit', function (e) {
      var drawer = drawerEl();
      if (!drawer) return;                 // no drawer -> leave the old behaviour alone
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      var spinner = form.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      var fd = new FormData(form);
      try {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (err) { /* sections are an optimisation, not a requirement */ }

      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) { window.location = cartUrl; return; }   // sold out etc -> old path
          if (typeof drawer.setActiveElement === 'function' && btn) drawer.setActiveElement(btn);
          drawer.renderContents(data);     // renderContents() opens the drawer itself
        })
        .catch(function () { window.location = cartUrl; })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          if (spinner) spinner.classList.add('hidden');
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
